module.exports = __webpack_public_path__ + "static/media/check-icon.1a6b0d10.svg";